<div class="simple-card m-b-20"><page-title></page-title></div>

<div class="simple-card">
  <p class="m-b-12 h5">{{ 'quotes.history.searchByDateRange' | cxTranslate }}</p>
  <form [formGroup]="dateRangeForm" class="quotes-history__form" (ngSubmit)="onSearch()">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="form-group w custom-date-picker">
          <label for="fromDate">{{ 'quotes.history.form.from' | cxTranslate }}</label>
          <p-datepicker
            formControlName="fromDate"
            dateFormat="mm/dd/yy"
            showIcon="true"
            inputStyleClass="form-control"
            placeholder="dd/mm/yy"
            allowedKeysToDatePicker
            >
          </p-datepicker>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group custom-date-picker">
          <label for="toDate">{{ 'quotes.history.form.to' | cxTranslate }}</label>
          <p-datepicker
            formControlName="toDate"
            dateFormat="mm/dd/yy"
            showIcon="true"
            inputStyleClass="form-control"
            placeholder="dd/mm/yy"
            allowedKeysToDatePicker
            >
          </p-datepicker>
        </div>
      </div>
      <div class="col-12 col-md-4 d-flex v-end">
        <div class="form-group w-100">
          <button type="submit" class="btn btn-primary btn-sm w-100">
            <span class="material-symbols-outlined d-flex m-r-4"> search </span> {{ 'quotes.history.search' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <button class="btn-link h6" (click)="navigate()">{{ 'quotes.history.requestNewQuote' | cxTranslate }}</button>
</div>

@if (quotes$ | async; as quotes) {
  <div class="simple-card">
    <quotes-history-table [form]="dateRangeForm" [quotes]="quotes"></quotes-history-table>
  </div>
}
